import { render, staticRenderFns } from "./join-us.vue?vue&type=template&id=3ca5567a&scoped=true&"
import script from "./join-us.vue?vue&type=script&lang=js&"
export * from "./join-us.vue?vue&type=script&lang=js&"
import style0 from "./join-us.vue?vue&type=style&index=0&id=3ca5567a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca5567a",
  null
  
)

export default component.exports